import { Search, GlobalSearchTab } from "@/models/search/Search";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface SearchStore {
  isSearchbarOpen: boolean;
  setIsSearchbarOpen: (isSearchbarOpen: boolean) => void;
  isFilterOpen: boolean;
  setIsFilterOpen: (isFilterOpen: boolean) => void;
  searchQuery: Search;
  setSearchQuery: (searchQuery: Search | ((prev: Search) => Search)) => void;
  resetSearchFilter: () => void;
}

const sessionStorageImpl = {
  getItem: (name: string): string | null => {
    if (typeof window === "undefined") return null;
    return sessionStorage.getItem(name);
  },
  setItem: (name: string, value: string): void => {
    if (typeof window === "undefined") return;
    sessionStorage.setItem(name, value);
  },
  removeItem: (name: string): void => {
    if (typeof window === "undefined") return;
    sessionStorage.removeItem(name);
  },
};

const useSearchStore = create<SearchStore>()(
  persist(
    (set, get) => ({
      isSearchbarOpen: false,
      searchQuery: {
        searchTerm: "",
        searchTags: [],
        tab: GlobalSearchTab.All,
      },
      isFilterOpen: false,
      setIsFilterOpen: (isFilterOpen) => set({ isFilterOpen: isFilterOpen }),
      setSearchQuery: (searchQuery) => {
        if (typeof searchQuery === "function") {
          set((state) => ({ searchQuery: searchQuery(state.searchQuery) }));
        } else {
          set({ searchQuery });
        }
      },
      setIsSearchbarOpen: (isSearchbarOpen) => set({ isSearchbarOpen }),
      resetSearchFilter: () =>
        set({
          searchQuery: {
            searchTerm: get().searchQuery.searchTerm,
            searchTags: [],
            tab: get().searchQuery.tab,
          },
        }),
    }),
    {
      name: "search-store",
      storage: createJSONStorage(() => sessionStorageImpl),
      partialize: (state) => ({
        searchQuery: state.searchQuery,
      }),
    }
  )
);

export default useSearchStore;
